import { useMemo } from 'react';

import { useActiveClusters } from 'features/organization/_hooks';
import { useBestPracticesFiltersQuery } from 'hooks/queries/security-insights';

import { LabelsSelect as LabelsSelectBase } from '../../_components/LabelsSelect';
import { useClustersOrFixture } from '../../hooks/useClustersOrFixture';

type Props = {
  initialValue?: string[];
  clusterIds?: string[];
};

export const LabelsSelect = ({
  initialValue,
  clusterIds: scopedClusterIds,
}: Props) => {
  const { clusters: _clusters } = useActiveClusters();
  const { clusters } = useClustersOrFixture(_clusters);
  const clusterIds = useMemo(
    () => scopedClusterIds ?? clusters?.map((cluster) => cluster.id) ?? [],
    [scopedClusterIds, clusters]
  );
  const { isLoading, filters, error, refetch } = useBestPracticesFiltersQuery({
    clusterIds,
  });

  return (
    <LabelsSelectBase
      isLoading={isLoading}
      labels={filters?.labels}
      error={!!error}
      refetch={refetch}
      criterion="labels"
      initialValue={initialValue}
    />
  );
};
